import React from 'react';
import { ArrowUpRight, Mail, Menu, Phone, X } from 'lucide-react';
import { translate } from '../i18n';

const Header = ({ currentPage, setCurrentPage, pages, mobileMenuOpen, setMobileMenuOpen, nomUsine, language, setLanguage }) => {
  const t = (text) => translate(language, text);
  const languageControl = (
    <div className="language-switch" role="group" aria-label={t('Langue du site')}>
      {['fr', 'en'].map((option) => (
        <button key={option} type="button" onClick={() => setLanguage(option)} aria-pressed={language === option}>
          {option.toUpperCase()}
        </button>
      ))}
    </div>
  );
  return (
    <header className="header">
      <div className="header-topbar">
        <div className="header-topbar-inner">
          <span>{t('Fourniture B2B · Phosphate Dicalcique Feed Grade')}</span>
          <div className="header-topbar-links">
            <a href="tel:+21670279320"><Phone size={13} /> +216 70 279 320</a>
            <a href="mailto:commercial@phosphokym.com.tn"><Mail size={13} /> {t('Équipe commerciale')}</a>
          </div>
        </div>
      </div>
      <div className="header-content">
        {/* Logo Phosphokym avec image */}
        <button
          className="logo"
          onClick={() => setCurrentPage('accueil')}
          aria-label={t("Phosphokym - Retourner à l'accueil")}
          type="button"
        >
          {/* Image du logo */}
          <img 
            src="/images/phosphokym.png"
            alt="Phosphokym Logo"
            className="logo-img"
            onError={(e) => {
              if (process.env.NODE_ENV === 'development') {
                console.error("Erreur de chargement de l'image:", e.target.src);
              }
              e.target.style.display = 'none';
              if (e.target.nextElementSibling) {
                e.target.nextElementSibling.style.display = 'flex';
              }
            }}
          />
          
          {/* Texte fallback si l'image ne charge pas */}
          <div className="logo-text-container" style={{ display: 'none' }}>
            <div className="logo-main">{nomUsine}</div>
            <div className="logo-sub">Dicalcium Phosphate · Feed Grade</div>
          </div>
        </button>

        {/* Navigation Desktop */}
        <nav className="nav-desktop" role="navigation" aria-label={t('Navigation principale')}>
          <span className="nav-context">{t('Explorer')}</span>
          {pages.filter(page => page.id !== 'devis').map(page => (
            <button
              key={page.id}
              onClick={() => setCurrentPage(page.id)}
              className={`nav-link ${currentPage === page.id ? 'active' : ''}`}
              aria-current={currentPage === page.id ? 'page' : undefined}
            >
              {page.label}
            </button>
          ))}
          {languageControl}
          <button className="nav-quote-btn" onClick={() => setCurrentPage('devis')}>
            {t('Demander un devis')} <ArrowUpRight size={15} />
          </button>
        </nav>

        {/* Bouton Menu Mobile */}
              <button
          className="menu-btn"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label={mobileMenuOpen ? t('Fermer le menu') : t('Ouvrir le menu')}
          aria-expanded={mobileMenuOpen}
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Menu Mobile */}
      {mobileMenuOpen && (
        <nav className="mobile-menu" role="navigation" aria-label={t('Navigation mobile')}>
          <div className="mobile-menu-heading"><span>{t('Navigation')}</span><small>DCP · Animal Nutrition</small></div>
          {pages.map(page => (
            <button
              key={page.id}
              onClick={() => {
                setCurrentPage(page.id);
                setMobileMenuOpen(false);
              }}
              className={`mobile-nav-link ${currentPage === page.id ? 'active' : ''}`}
              aria-current={currentPage === page.id ? 'page' : undefined}
            >
              {page.label}
            </button>
          ))}
          {languageControl}
        </nav>
      )}
    </header>
  );
};

export default Header;